import { flatten } from '../../../common/flatten';
import {
  loadableEnum,
  TUseMakeRequestReturn,
} from '../../../common/useMakePHPRequest';
import { trackSaveUpdateCard } from '../../../common/userTracking';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';

/**
 * Declare StripeCheckout
 * @see https://stackoverflow.com/questions/12709074/how-do-you-explicitly-set-a-new-property-on-window-in-typescript
 */
declare global {
  // eslint-disable-next-line no-unused-vars, autofix/no-unused-vars
  interface Window {
    StripeCheckout: any;
    chrome: any;
  }
}

export const showUpdateCard = (
  enqueueSnackbarWithStyles: any,
  phpRequest: TUseMakeRequestReturn,
  userid?: string,
  onClose?: () => void
) => (event: any) => {
  const stripeUpdateCardhandler = window.StripeCheckout.configure({
    key: process.env.VITE_APP_STRIPE_KEY,
    zipCode: true,
    image: `${process.env.VITE_APP_PUBLIC_URL}/media/logos/k-logo.png`,
    locale: 'auto',
    // zipCode: true,
    allowRememberMe: false,
    token: async function (token: any) {
      // Use the token to create the charge with a server-side script.
      // You can access the token ID with `token.id
      // Send data to server to create customer and store customer data
      const { response, exception, status } = await phpRequest({
        methodName: methodNameEnum.SUBMIT_UPDATE_CARD,
        payload: {
          userid,
          ...flatten(token, 'token'),
        },
      });
      if (status === loadableEnum.HAS_VALUE) {
        enqueueSnackbarWithStyles({
          message: 'Successfully Updated Credit Card',
          alertProps: {
            severity: 'success',
          },
        });
        // eslint-disable-next-line autofix/no-console, no-console
        console.log('Update card success', response);
        trackSaveUpdateCard();
      } else {
        enqueueSnackbarWithStyles({
          message: 'Failed to Update Credit Card',
          alertProps: {
            severity: 'error',
          },
        });
        // eslint-disable-next-line autofix/no-console, no-console
        console.log('Update card fail', exception);
      }
    },
  });

  // Open Checkout with further options
  stripeUpdateCardhandler.open({
    name: 'Kixie.com',
    panelLabel: 'Update Card',
    locale: 'auto',
    // zipCode: true,
    allowRememberMe: false,
    closed: onClose,
  });

  // stripeUpdateCardhandler.close();
};
